var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuoteyHomepageBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    style: {
      enableBackground: "new 0 0 720 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#76A7DA;}\n\t.st2{fill:#C6E6F6;}\n\t.st3{fill:#1A4684;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.9,273.8h89c21.8,0,39.7,17.9,39.7,39.7v0c0,21.8-17.9,39.7-39.7,39.7h-89c-21.8,0-39.7-17.9-39.7-39.7v0 C274.1,291.7,292,273.8,313.9,273.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.1,412.4c-0.7,0-1.3-0.1-2-0.1c-55.6,0-104.2,43.8-104.2,105.5l43.7-11.4c5.4,28.8,30.7,50.7,61,50.7 c0.5,0,1,0,1.5,0V412.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M359.1,412.4v144.7c29.7-0.7,54.2-22.2,59.5-50.5l46.7,11.2C465.3,459.2,414.4,413.5,359.1,412.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.6,236.4H360v27.1h43.6c28.4,0,47.3,21,47.3,49.4c0,28.4-18.9,51.5-47.3,51.5H360v25h43.6 c43.3,0,76.5-33.2,76.5-76.5C480.1,269.5,446.9,236.4,403.6,236.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360,364.4h-43.6c-28.4,0-51.5-23.1-51.5-51.5c0-28.4,23.1-49.4,51.5-49.4H360v-27.1h-43.6 c-43.3,0-78.6,33.2-78.6,76.5c0,43.3,35.2,76.5,78.6,76.5H360V364.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M405.7,400.6h-93.1c-46.4,0-84.1-37.7-84.1-84.1v-7.3c0-46.4,37.7-84.1,84.1-84.1h93.1 c46.4,0,84.1,37.7,84.1,84.1v7.3C489.8,362.9,452,400.6,405.7,400.6z M312.6,237.6c-39.5,0-71.6,32.1-71.6,71.6v7.3 c0,39.5,32.1,71.6,71.6,71.6h93.1c39.5,0,71.6-32.1,71.6-71.6v-7.3c0-39.5-32.1-71.6-71.6-71.6H312.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M401.5,364.8h-86.2c-28.3,0-51.2-23-51.2-51.2c0-28.3,23-51.2,51.2-51.2h86.2c28.3,0,51.2,23,51.2,51.2 C452.7,341.8,429.7,364.8,401.5,364.8z M315.3,274.8c-21.4,0-38.8,17.4-38.8,38.8c0,21.4,17.4,38.8,38.8,38.8h86.2 c21.4,0,38.8-17.4,38.8-38.8c0-21.4-17.4-38.8-38.8-38.8H315.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 322.7,
    cy: 313,
    r: 20.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 358.7,
    cy: 498.6,
    r: 31.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 399,
    cy: 313.6,
    r: 20.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 358.8,
    cy: 180.8,
    r: 18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.2,
    y: 190.3,
    className: "st3",
    width: 11.3,
    height: 36.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.7,334.8v-42.4c0-2.6,0.7-5.1,1.9-7.3c-1.3-0.3-2.6-0.5-4-0.5c-9.1,0-16.5,7.4-16.5,16.5v25 c0,9.1,7.4,16.5,16.5,16.5c1.4,0,2.7-0.2,4-0.5C234.4,339.9,233.7,337.4,233.7,334.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M486.3,334.8v-42.4c0-2.6-0.7-5.1-1.9-7.3c1.3-0.3,2.6-0.5,4-0.5c9.1,0,16.5,7.4,16.5,16.5v25 c0,9.1-7.4,16.5-16.5,16.5c-1.4,0-2.7-0.2-4-0.5C485.6,339.9,486.3,337.4,486.3,334.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358,412.4c-55.6,0-104.2,43.8-104.2,105.5l43.7-11.4c5.4,28.8,30.7,50.7,61,50.7c30.3,0,55.6-21.8,61-50.5 l46.7,11.2C466.2,458.5,414.1,412.4,358,412.4z M407.6,496.8c0,27.5-22.3,49.8-49.8,49.8s-49.8-22.3-49.8-49.8 c0-2.2,0.2-4.4,0.4-6.5l-39.4,9.6c6.4-45.5,45.7-76.7,89.9-76.7c44.5,0,86.1,32.6,93.2,76.6l-44.9-9.5 C407.5,492.4,407.6,494.6,407.6,496.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteyHomepageBot);
export default __webpack_public_path__ + "static/media/quotey-homepage-bot.458e5df7a9e2377617f9d996734a7364.svg";
export { ForwardRef as ReactComponent };